import React, { useState, useEffect } from "react";
import { shape } from "prop-types";
import { Col, Row } from "react-bootstrap";
import Button from "pages/_components/Button";
import { useDispatch } from "react-redux";
import { actions as debinActions } from "reducers/debin";
import Avatar from "pages/_components/Avatar";
import { Field } from "formik";
import SelectorInput from "pages/_components/fields/formik/SelectorInput";
import * as i18n from "util/i18n";

const Applicant = ({ beneficiaryData, seller, values, debinPrestacion }) => {
    const dispatch = useDispatch();

    const [document, setDocument] = useState({ type: "CUIT", value: null });

    const selectBeneficiary = () => {
        dispatch(debinActions.debinSeller(document.value));
        dispatch(
            debinActions.setdebinPrestacionData({
                ...values,
                document,
            }),
        );
    };

    useEffect(() => {
        if (debinPrestacion.document) {
            setDocument(debinPrestacion.document);
        }
    }, [debinPrestacion]);

    const selectBeneficiaryApplicant = (beneficiary) => {
        dispatch(debinActions.setBeneficiary(beneficiary));
    };

    useEffect(() => {
        if (seller?.cuenta) {
            dispatch(
                debinActions.getAccountInfoByCbuCbuCvuAliasApplicant(
                    seller?.cuenta[0]?.cbu,
                    selectBeneficiaryApplicant,
                ),
            );
        }
    }, [seller]);

    const cleanBeneficiary = () => {
        dispatch(debinActions.setBeneficiary({}));
    };

    return (
        <>
            <Row>
                <Col xs={12} md={6}>
                    <Field
                        component={SelectorInput}
                        name="document"
                        hidePlaceholder
                        selectProps={{
                            name: "documentType",
                            value: {
                                value: document.type,
                                label: document.type,
                            } /* values.documentType */,
                            options: [
                                { value: "CUIT", label: "CUIT" },
                                { value: "CUIL", label: "CUIL" },
                                { value: "CDI", label: "CDI" },
                            ],
                        }}
                        isFocused
                        label={i18n.get(`echecks.document`)}
                        inputProps={{
                            name: "document",
                            value: document.value,
                            inputmode: "numeric",
                        }}
                        onChange={(type, stringDocument) => {
                            setDocument({
                                type: type?.value ? type.value : type,
                                value: stringDocument,
                            });
                        }}
                    />
                </Col>
                <Col xs={12} md={4} style={{ display: "flex", alignItems: "end", marginBottom: "16px" }}>
                    <Button
                        className="btn-outline"
                        label="forms.bankselector.search"
                        onClick={selectBeneficiary}
                        disabled={beneficiaryData?.document}
                    />
                </Col>
            </Row>
            {beneficiaryData?.cbu && (
                <div className="debin__beneficiary box border">
                    <div className="debin__beneficiary-info">
                        <Avatar
                            user={{
                                userFullName: beneficiaryData?.name || beneficiaryData?.recipientName,
                                defaultAvatarId: 0,
                                email: beneficiaryData?.email,
                            }}
                        />
                        <span className="debin__beneficiary-name">{`${beneficiaryData?.name || beneficiaryData?.recipientName}`}</span>
                    </div>
                    <Button onClick={() => cleanBeneficiary()} image="images/figma/icon/cross.svg" bsStyle="link" />
                </div>
            )}
        </>
    );
};

Applicant.propTypes = {
    beneficiaryData: shape({}),
    seller: shape({}),
    values: shape({}),
    debinPrestacion: shape({}),
};

Applicant.defaultProps = {
    beneficiaryData: {},
    seller: {},
    values: {},
    debinPrestacion: {},
};

export default Applicant;
